import type { Artist as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

/**
 * The identity slice of an artist — what the rider read selects (`artist { id name }`) and all
 * the rider screens display.
 *
 * Deliberately partial: the full artist read and write (bio, links, attachments, sync) still live
 * on the legacy `api/Artist` module, which already runs on `gqlApiClient` and only needs its
 * generated types repointed. When that migration lands, *grow* this mapper — don't fork a third.
 */
export type Artist = {
  id?: number;
  name?: string;
};

export const fromGql = (item: GQLItem): Artist => take<Artist>(item, 'id', 'name');
